import { Model } from "@vuex-orm/core";

export default class CustomerLookup extends Model {
  static entity = "customerLookups";

  static fields() {
    return {
      id: this.attr(),
      name: this.attr(),
      phone: this.attr(),
      date: this.attr()
    };
  }
}
